import { render, staticRenderFns } from "./CompetitionHome.vue?vue&type=template&id=057189ea&scoped=true"
import script from "./CompetitionHome.vue?vue&type=script&lang=js"
export * from "./CompetitionHome.vue?vue&type=script&lang=js"
import style0 from "./CompetitionHome.vue?vue&type=style&index=0&id=057189ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057189ea",
  null
  
)

export default component.exports